import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    linkVariantDefault: 'underscored',
    linkVariantQuiet: 'underscore'
  }
} satisfies VfConfig['link']
